/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ registered: NonNullable<unknown>, already: NonNullable<unknown> }} Csv_Import_DoneInputs */



/**
* | output |
* | --- |
* | "{registered} player(s) registered, {already} already in the tournament." |
*
* @param {Csv_Import_DoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_done = /** @type {((inputs: Csv_Import_DoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_DoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.registered} joueur(s) inscrit(s), ${i?.already} déjà dans le tournoi.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.registered} jugador/es inscrito/s, ${i?.already} ya en el torneo.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.registered} jogador/es inscrito/s, ${i?.already} já no torneio.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.registered} giocatore/i iscritto/i, ${i?.already} già nel torneo.`)
	return /** @type {LocalizedString} */ (`${i?.registered} player(s) registered, ${i?.already} already in the tournament.`)
});